import { Link } from 'react-router-dom';
import { getModuleIcon } from '../data/modules';
import { ChevronRight, CheckCircle2 } from 'lucide-react';
import { SECTIONS } from '../lib/sectionTheme';

const T = SECTIONS.training;

export default function ModuleTile({ module, progress = 0 }) {
  const Icon = getModuleIcon(module.icon);
  const done = progress === 100;
  return (
    <Link to={`/module/${module.id}`} data-testid={`module-tile-${module.id}`}
      className="module-tile group block bg-card border border-border rounded-xl p-6 hover:shadow-md relative overflow-hidden"
      style={{ transition: 'box-shadow 0.2s, border-color 0.2s, transform 0.2s' }}>
      <div className="absolute top-0 left-0 w-1 h-full transition-colors" style={{ backgroundColor: progress > 0 ? T.color : 'transparent' }} />
      {done && (
        <div className="absolute top-3 right-3 flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-green-500/10 text-green-500">
          <CheckCircle2 className="w-3 h-3" /> Done
        </div>
      )}
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: `${module.color}12` }}>
          <Icon className="w-5 h-5" style={{ color: module.color }} strokeWidth={1.5} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-['Outfit'] text-base font-semibold text-foreground group-hover:text-[color:var(--i3-teal)] transition-colors">{module.title}</h3>
          <p className="text-xs text-muted-foreground mt-0.5">{module.subtitle}</p>
        </div>
      </div>
      <p className="text-sm text-muted-foreground mt-3 leading-relaxed line-clamp-2">{module.description}</p>
      {/* Progress bar */}
      <div className="mt-4 pt-3 border-t border-border">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-[11px] text-muted-foreground font-medium">{module.steps.length} steps</span>
          <span className="text-[11px] font-semibold" style={{ color: progress > 0 ? T.color : 'var(--muted-foreground)' }}>{progress}%</span>
        </div>
        <div className="h-1.5 bg-muted rounded-full overflow-hidden">
          <div className="h-full rounded-full transition-all" style={{ width: `${progress}%`, backgroundColor: T.color }} />
        </div>
      </div>
    </Link>
  );
}
